import styled from 'styled-components';
import { playGrey10 } from '../../ui-components/design-tokens';
import { device } from '../../ui-components/breakpoints';
import { PlayListHeading } from '../../ui-components/typography/PlayListHeading.styles';

export const StyledRecommendations = styled.section`
    margin-bottom: 30px;
`;

export const Heading = styled(PlayListHeading)`
    width: 100%;
    display: block;
    padding: 10px 10px 15px 0;
`;

export const DisplayWindow = styled.article`
    display: block;
    width: 100%;
    background: ${playGrey10};
    margin: 0 0 5px;

    @media ${device.GteSmall} {
        display: inline-block;
        width: calc(50% - 2.5px);
    }

    @media ${device.GteXLarge} {
        width: calc(33.333% - 2.5px);
    }
`;

export const Placeholder = styled.div`
    content: '';
    display: block;
    padding-top: 56.25%;
    overflow: hidden;
`;
